import { Action } from "../actions";
import { MiniMessageActionTypes } from "../constants";

export interface MiniMessageBoxState {
  show: boolean;
  type: string;
  message: string;
}

const DEFAULT_MINI_MESSAGE_BOX_STATE: MiniMessageBoxState = {
  type: "",
  message: "",
  show: false,
};

export function miniMessageBoxReducer(state: MiniMessageBoxState = DEFAULT_MINI_MESSAGE_BOX_STATE, action: Action): MiniMessageBoxState {
  if (action.type === MiniMessageActionTypes.SHOW_MINI_MESSAGE_BOX) {
    return { ...state, ...action.payload };
  } else if (action.type === MiniMessageActionTypes.HIDE_MINI_MESSAGE_BOX) {
    return { ...state, ...DEFAULT_MINI_MESSAGE_BOX_STATE };
  } else {
    return state;
  }
}
